import React from 'react';
import { useDispatch } from 'react-redux';
import { Link } from 'react-router-dom';
import { setSearchText } from '../../features/filter/filterSlice';

const NavBar = () => {
    const dispatch = useDispatch()
    const handleChange = (e) => {
        dispatch(setSearchText(e.target.value))
    }
    return (
        <nav className="container relative py-3">
            <div className="flex items-center justify-between">
                <Link to="/">
                    <img src="/images/logo.svg" />
                </Link>
                <div className="flex-1 max-w-xs search-field group">
                    <i className="fa-solid fa-magnifying-glass search-icon group-focus-within:text-blue-500"></i>
                    <input onChange={handleChange} type="text" placeholder="Search Task" className="search-input" id="lws-searchTask" />
                </div>
            </div>
        </nav>
    );
};

export default NavBar;